module.exports = __webpack_public_path__ + "img/welfare-ico-3.ffb66115.png";